import React from 'react'
import { Layout, Menu } from 'antd'
import { NavLink, useLocation } from 'react-router-dom'
import { useSelector } from 'react-redux'

import {
  UserOutlined,
  CalendarOutlined,
  DashboardOutlined,
  CrownOutlined,
  HddOutlined,
  UsergroupAddOutlined,
  AppstoreOutlined
} from '@ant-design/icons'

import { RiArticleLine } from 'react-icons/ri'
import { ImBooks } from 'react-icons/im'

const SideNav = (props) => {
  const { collapsed, onCollapse } = props
  const { Sider } = Layout

  let currentPath = useLocation().pathname
  const user = useSelector((state) => state.auth.user)

  // dummy fix for side nav highlight
  if (currentPath.includes('/app/course/'))
    currentPath = currentPath.replace('/app/course/', '/app/courses/')

  return (
    <Sider
      collapsible
      collapsed={collapsed}
      onCollapse={onCollapse}
      breakpoint="lg"
      style={{
        overflow: 'auto',
        height: '100vh',
        position: 'fixed',
        left: 0
      }}
    >
      <div
        style={{ cursor: 'pointer' }}
        onClick={() =>
          (window.location = 'https://lms.spanidea.com/app/dashboard')
        }
      >
        {collapsed ? (
          <span style={{ display: 'flex', justifyContent: 'center' }}>
            <img
              style={{
                width: '50px',
                marginTop: '5px',
                marginBottom: '10px'
              }}
              src="https://spanlogo.s3.ap-south-1.amazonaws.com/Spanidea-Blue-Favion-2025.png"
              alt="spanidea_logo"
            />
          </span>
        ) : (
          <img
            style={{
              width: '170px',
              marginTop: '20px',
              marginLeft: '10px',
              marginBottom: '15px'
            }}
            src="https://spanlogo.s3.ap-south-1.amazonaws.com/Spanidea-light-svg-logo.svg"
            alt="spanidea_logo"
          />
        )}
      </div>
      <Menu
        theme="dark"
        mode="inline"
        activeKey={currentPath}
        selectedKeys={currentPath}
      >
        <Menu.Item key="/app/dashboard" icon={<DashboardOutlined />}>
          <NavLink to="/app/dashboard">Dashboard</NavLink>
        </Menu.Item>
        {user?.role === 'admin' && (
          <>
            <Menu.Item key="/app/instructors" icon={<UsergroupAddOutlined />}>
              <NavLink to="/app/instructors">Instructors</NavLink>
            </Menu.Item>
            <Menu.Item key="/app/category" icon={<AppstoreOutlined />}>
              <NavLink to="/app/category">Category</NavLink>
            </Menu.Item>
          </>
        )}
        <Menu.Item key="/app/courses" icon={<ImBooks />}>
          <NavLink to="/app/courses">Courses</NavLink>
        </Menu.Item>
        <Menu.Item key="/app/certificate" icon={<CrownOutlined />}>
          <NavLink to="/app/certificate">Certificates</NavLink>
        </Menu.Item>
        <Menu.Item key="/app/calendar" icon={<CalendarOutlined />}>
          <NavLink to="/app/calendar">Calendar</NavLink>
        </Menu.Item>
        <Menu.Item key="/app/articles" icon={<RiArticleLine />}>
          <NavLink to="/app/articles">Articles</NavLink>
        </Menu.Item>
        <Menu.Item key="/app/acheivements" icon={<CrownOutlined />}>
          <NavLink to="/app/acheivements">Achievements</NavLink>
        </Menu.Item>
        {user?.role !== 'student' && (
          <Menu.Item key="/app/archives" icon={<HddOutlined />}>
            <NavLink to="/app/archives">Archives</NavLink>
          </Menu.Item>
        )}
        <Menu.Item key="/app/profile" icon={<UserOutlined />}>
          <NavLink to="/app/profile">Profile</NavLink>
        </Menu.Item>
      </Menu>
    </Sider>
  )
}

export default SideNav
